import React from 'react';
import PropTypes from 'prop-types';
import { FlexGrid } from '@gasbuddy/react-components';
import BrandPropType from '../../../utils/prop-types/brand';
import styles from './styles.css';

import { DEFAULT_BRAND } from './brand-edit-modal';

const BrandInfo = ({ isFuelBrand, isCstoreBrand, brand, hideBrandInfo }) => (
  <FlexGrid className={styles.brandInfo}>
    <FlexGrid.Column mobile={4} className={styles.brandIcon}>
      <img src={(brand || DEFAULT_BRAND).image_url} alt={(brand || DEFAULT_BRAND).display_name} />
    </FlexGrid.Column>
    { !hideBrandInfo
      && (
        <FlexGrid.Column mobile={8} className={styles.brandInfoText}>
          <div className={styles.brandInfoHeader}>
            {
              (isFuelBrand && 'Fuel')
              || (isCstoreBrand && 'C-Store')
              || 'Branding type not specified'
            }
          &nbsp;Brand
          </div>
          <div className={styles.brandInfoName}>
            {(brand || DEFAULT_BRAND).display_name}
          </div>
        </FlexGrid.Column>
      )}
  </FlexGrid>
);

BrandInfo.propTypes = {
  isFuelBrand: PropTypes.bool,
  isCstoreBrand: PropTypes.bool,
  hideBrandInfo: PropTypes.bool,
  brand: BrandPropType,
};

BrandInfo.defaultProps = {
  isFuelBrand: false,
  isCstoreBrand: false,
  hideBrandInfo: false,
  brand: DEFAULT_BRAND,
};

export default BrandInfo;
